<app-tool-loader [isLoading]="isLoading() || isSelectingOperation()" [positionUnset]="true">
  <div class="flex flex-col w-full h-full min-h-0 overflow-hidden p-1">
    <!-- Confirmation Dialog -->
    <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

    <!-- Toggle Button -->
    <p-button class="outlined-button" outlined="true" pTooltip="{{ drawerOpen ? 'Collapse List' : 'Expand List' }}"
      icon="{{drawerOpen ? 'pi pi-angle-double-left' : 'pi pi-angle-double-right'}}"
      (onClick)="drawerToggle()">
    </p-button>

    @if (!drawerOpen && operations) {
      <p-select [options]="operations"
        [disabled]="isSelectingOperation()"
        [ngModel]="selectedOperation[0]" dataKey="id" appendTo="body" optionLabel="name"
        (onChange)="onOperationSelect($event, false)">
      </p-select>
    }

    <div class="flex flex-1 min-h-0 overflow-hidden">
      <!-- Drawer Section -->
      @if (drawerOpen) {
      <div class="z-[2] flex-[0.3] min-w-[150px] min-h-0 flex-shrink flex flex-col overflow-hidden">
        <div class="mb-2">
          <p-button class="outlined-button" outlined="true" severity="success" 
            label="Add Operation" [disabled]="isSelectingOperation()" (onClick)="addOperation()">
          </p-button>
        </div>
        <div class="flex-1 min-h-0 overflow-auto">
          <p-listbox [scrollHeight]="''" [options]="operations" optionLabel="name" dataKey="id"
            (onChange)="onOperationSelect($event)"
            cdkDropList (cdkDropListDropped)="drop($event)"
            [ngModel]="selectedOperation[0]">
            <ng-template let-operation #item>
              <div class="flex items-center justify-between w-full" cdkDrag>
                <div class="col-span-10">
                  <span class="text-xs" style="word-break: break-all;">{{ operation.name }}</span>
                </div>
                <div class="flex items-center">
                  <i class="pi pi-copy p-1 !text-cyan-400" pTooltip="Clone Operation"
                    (click)="cloneOperation(operation)">
                  </i>
                  <i class="pi pi-trash !text-red-400" pTooltip="Delete Operation"
                    (click)="deleteOperation(operation)">
                  </i>
                </div>
              </div>
            </ng-template>
          </p-listbox>
        </div>
      </div>
      }

      <!-- Main Content Section -->
       @if (!isLoading()) {
        <div [ngClass]="{'flex-[0.7]': drawerOpen, 'flex-[1]': !drawerOpen}" class="min-w-0 min-h-0 h-full p-2 overflow-hidden">
          <app-operation-data [isReadOnly]="userRoles?.readOnly" [disabled]="operations?.length === 0 || isLoading()"
            [operation]="selectedOperationDetail$ | async" (operationUpdate)="updateOrCreateOperation($event)"
            [previousOperations]="previousOperations" [selectedOperation]="selectedOperation" [user]="user" [units]="userUnits" [wellType]="wellType" class="block h-full min-h-0"
          ></app-operation-data>
        </div>
      }
    </div>
    
  </div>
</app-tool-loader>
